import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { STORE, waLink } from "@/lib/store";
import { Seo } from "@/components/Seo";

export default function Contatti() {
  return (
    <main data-testid="contatti-page" className="mx-auto max-w-4xl px-4 py-12 sm:px-6">
      <Seo route="/contatti" />
      <h1 className="font-display text-4xl font-extrabold text-neutral-900">Contatti</h1>
      <div className="mt-8 grid gap-6 md:grid-cols-2">
        <div className="rounded-2xl border border-neutral-200 bg-white p-6 space-y-4">
          <div className="flex items-center gap-3 text-neutral-700"><Phone className="h-5 w-5 text-black" /> {STORE.phone}</div>
          <div className="flex items-center gap-3 text-neutral-700"><Mail className="h-5 w-5 text-black" /> {STORE.email}</div>
          <div className="flex items-center gap-3 text-neutral-700"><MapPin className="h-5 w-5 text-black" /> {STORE.address || STORE.city}</div>
          <a href={waLink("Ciao iPhix!")} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 font-semibold text-white"><MessageCircle className="h-5 w-5" /> WhatsApp</a>
        </div>
        <div className="rounded-2xl border border-neutral-200 bg-white p-6">
          <h3 className="mb-3 flex items-center gap-2 font-display font-semibold text-neutral-900"><Clock className="h-5 w-5 text-black" /> Orari</h3>
          <ul className="space-y-1 text-sm text-neutral-600">
            <li className="flex justify-between"><span>Lun - Ven</span><span>09:30–13:00 / 15:30–20:00</span></li>
            <li className="flex justify-between"><span>Sabato</span><span>09:30–13:00</span></li>
            <li className="flex justify-between"><span>Domenica</span><span className="text-rose-400">Chiuso</span></li>
          </ul>
        </div>
      </div>
    </main>
  );
}
